import { render, staticRenderFns } from "./proses_sk_tunggal_pembatalan.vue?vue&type=template&id=f854c7ee&"
import script from "./proses_sk_tunggal_pembatalan.vue?vue&type=script&lang=js&"
export * from "./proses_sk_tunggal_pembatalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports